// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q7q0-","index":"styles_index__2_WfA"};